// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-header {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  overflow: hidden;
  border-bottom: 1px solid #e5e7eb;
}

.tab-buttons {
  display: flex;
  gap: 24px;
}

.tab-button {
  width: max-content;
  padding: 16px 0;
  background: none;
  border: none;
  font-size: 16px;
  color: #6b7280;
  cursor: pointer;
  position: relative;
}

.tab-button.active {
  color: #111827;
  font-weight: 500;
}

.tab-button.active::after {
  content: "";
  position: absolute;
  bottom: 6px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #0d9488;
}

.generate-letter-btn {
  width: max-content;
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #0d9488;
  color: white;
  border: none;
  border-radius: 10px;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 14px;
}

@media (max-width: 580px) {
  .tab-header {
    padding: 8px 10px;
    gap: 10px;
    overflow-x: auto;
  }
  .tab-buttons {
    gap: 8px;
  }
  .tab-button {
    max-width: 100px;
    padding: 10px 0;
  }
  .generate-letter-btn {
    width: 170px;
    gap: 8px;
    padding: 8px 16px;
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/selectedSessionComponent/TabHeader.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE;IACE,iBAAiB;IACjB,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,YAAY;IACZ,QAAQ;IACR,iBAAiB;IACjB,eAAe;EACjB;AACF","sourcesContent":[".tab-header {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 20px;\n  overflow: hidden;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.tab-buttons {\n  display: flex;\n  gap: 24px;\n}\n\n.tab-button {\n  width: max-content;\n  padding: 16px 0;\n  background: none;\n  border: none;\n  font-size: 16px;\n  color: #6b7280;\n  cursor: pointer;\n  position: relative;\n}\n\n.tab-button.active {\n  color: #111827;\n  font-weight: 500;\n}\n\n.tab-button.active::after {\n  content: \"\";\n  position: absolute;\n  bottom: 6px;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background-color: #0d9488;\n}\n\n.generate-letter-btn {\n  width: max-content;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #0d9488;\n  color: white;\n  border: none;\n  border-radius: 10px;\n  padding: 8px 16px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n@media (max-width: 580px) {\n  .tab-header {\n    padding: 8px 10px;\n    gap: 10px;\n    overflow-x: auto;\n  }\n  .tab-buttons {\n    gap: 8px;\n  }\n  .tab-button {\n    max-width: 100px;\n    padding: 10px 0;\n  }\n  .generate-letter-btn {\n    width: 170px;\n    gap: 8px;\n    padding: 8px 16px;\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
